import { Button } from "@chakra-ui/react";
import { MdCalendarMonth, MdHourglassBottom } from "react-icons/md";
import Moment from "react-moment";
import { numberToHour } from "utils";
import { useForfaitUsage, warningColor } from "hooks/useForfaitUsage";

interface InterventionProps {
  id: string;
  temps: number;
  refresh?: number;
}

function UserIntervention(props: InterventionProps): JSX.Element {
  const usage = useForfaitUsage(props.id, props.refresh);
  const time = usage ? props.temps - usage.consumed : null;
  const lastInter = usage?.lastIntervention;

  return (
    <>
      <Button
        leftIcon={<MdHourglassBottom />}
        colorScheme={time === null ? "teal" : warningColor(time)}
        variant="solid"
        mr={4}
      >
        {time === null ? "" : numberToHour(time)}
      </Button>
      {lastInter && (
        <Button
          rightIcon={<MdCalendarMonth />}
          colorScheme="teal"
          variant="outline"
        >
          {lastInter && <Moment format="DD/MM/YYYY">{lastInter}</Moment>}
        </Button>
      )}
    </>
  );
}

export default UserIntervention;
